import React from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import NonStretchedImage from '../NonStretchedImage/NonStretchedImage'

const ConservadorIcon = () => {
  const result = useStaticQuery(
    graphql`
      {
        file(relativePath: { eq: "conservador.png" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
              presentationWidth
            }
          }
        }
      }
    `
  );

  return (
    <NonStretchedImage
      fluid={result.file.childImageSharp.fluid}
      alt="Inversionista conservador"
    />
  )
}

export default ConservadorIcon;
